import * as Sentry from '@sentry/react'

export const feedback = Sentry.feedbackIntegration({
  colorScheme: 'light',
  autoInject: false,
  showBranding: false,
  isNameRequired: false,
  formTitle: 'Feedback',
  showEmail: false,
  showName: false,
  buttonLabel: 'Send Feedback',
  submitButtonLabel: 'Send Feedback',
  messagePlaceholder: 'What happened? What did you expect to happen?',
  onFormOpen: () => {
    const injectStyle = () => {
      const sentryFeedback = document.getElementById('sentry-feedback')
      if (sentryFeedback && sentryFeedback.shadowRoot) {
        const style = document.createElement('style')
        style.textContent = `
          :host {
            --inset: auto auto 0 0 !important;
          }
        `
        sentryFeedback.shadowRoot.appendChild(style)
      }
    }

    injectStyle()
  },
  useSentryUser: {
    name: 'username',
    email: 'email'
  }
})

export function init(): void {
  Sentry.init({
    enabled: window.env.ENV === 'production',
    dsn: window.env.SENTRY_DSN,
    environment: window.env.ENV ?? 'development',
    release: 'payment-frontend@1.0.0',

    integrations: [
      Sentry.browserTracingIntegration({
        enableInp: true
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      }),
      feedback
    ],

    tracesSampleRate: window.env.ENV === 'production' ? 0.1 : 1.0,

    replaysSessionSampleRate: window.env.ENV === 'production' ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,

    initialScope: {
      tags: {
        component: 'payment-frontend',
        version: '1.0.0'
      }
    },

    beforeSend(event, hint) {
      const error = hint.originalException

      // Ignore canceled/aborted requests (from AbortController)
      if (error instanceof Error) {
        if (
          error.name === 'CanceledError' ||
          error.name === 'AbortError' ||
          error.message === 'canceled'
        ) {
          return null
        }
      }

      return event
    }
  })
}

export function setUser(user: { id: string; email?: string; username?: string }) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.username
  })
}

export function addBreadcrumb(
  message: string,
  category: string = 'user',
  level: Sentry.SeverityLevel = 'info'
) {
  Sentry.addBreadcrumb({
    message,
    category,
    level,
    timestamp: Date.now() / 1000
  })
}
